import { Box, LinearProgress, Paper, Stack, Typography } from '@mui/material';
import { ConversionMetrics } from '../../types/dashboard';

interface ConversionCardProps {
  data?: ConversionMetrics;
  title?: string;
}

export const ConversionCard = ({ data, title = 'Conversion' }: ConversionCardProps) => {
  const rows = [
    { label: 'Lead → Student conversion', value: data?.leadConversionRate ?? 0, color: 'primary.main' },
    { label: 'Admission conversion', value: data?.admissionConversionRate ?? 0, color: 'secondary.main' },
    { label: 'Payment completion', value: data?.paymentCompletionRate ?? 0, color: 'success.main' },
  ];

  return (
    <Paper sx={{ p: 2, height: '100%' }}>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        {title}
      </Typography>
      <Stack spacing={2.5}>
        {rows.map((row) => (
          <Box key={row.label}>
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              {row.value}%
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 0.75 }}>
              {row.label}
            </Typography>
            <LinearProgress
              variant="determinate"
              value={Math.min(row.value, 100)}
              sx={{
                height: 6,
                borderRadius: 3,
                bgcolor: 'action.hover',
                '& .MuiLinearProgress-bar': { bgcolor: row.color, borderRadius: 3 },
              }}
            />
          </Box>
        ))}
      </Stack>
    </Paper>
  );
};
